import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useNavigate } from "react-router-dom";

import selectorApplicationLogo from "./selector_application.svg";
import style from "./SimpleHeader.module.css";
import classes from "./SimpleHeader.styles";

interface ComponentProps {
  menu: JSX.Element;
  title?: string;
}

/**
 * Simplified app header used within sub apps like the WDA/WSA
 */
function SimpleHeader({ menu }: ComponentProps) {
  const navigate = useNavigate();

  return (
    <Box display="block" displayPrint="none">
      <AppBar position="fixed">
        <Toolbar sx={classes.toolbar}>
          <img
            src={selectorApplicationLogo}
            alt={`Genedata Selector`}
            height="24"
            onClick={() => navigate(`/home`)}
            className={style.appLogo}
          />
          <Box flexGrow={1} minWidth={0} overflow="hidden" ml={2}>
            {menu}
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default SimpleHeader;
